var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearCircleBold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DD1122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2C7.832 2 2 7.832 2 15s5.832 13 13 13 13-5.832 13-13S22.168 2 15 2zm0 24C8.935 26 4 21.065 4 15S8.935 4 15 4s11 4.935 11 11-4.935 11-11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.707 9.293a1 1 0 0 0-1.414 0L15 13.586l-4.293-4.293a1 1 0 1 0-1.414 1.414L13.586 15l-4.293 4.293a1 1 0 1 0 1.414 1.414L15 16.414l4.293 4.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L16.414 15l4.293-4.293a1 1 0 0 0 0-1.414z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCircleBold);
export default __webpack_public_path__ + "static/media/clear_circle_BOLD.7f4c3e3cdefd9060ca146589446181c6.svg";
export { ForwardRef as ReactComponent };